import styled from 'styled-components';
import Button from '@veneer/core/dist/scripts/button';
import { stylesIf, breakpoints, hexToRgba, breakpointsRebrand } from '../utils/styleHelpers';
import { colors, spacing } from '@clientos/ui-toolkit';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(100vh - 25vw);
  max-width: 80vw;
  margin: 12.5vw auto;
  font-family: 'HP Simplified', Arial, sans-serif;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  @media screen and (min-width: 23.5rem) {
    justify-content: ${stylesIf('hasBody', 'space-evenly', 'center')};
  }
  @media screen and (min-width: 25.875rem) {
    justify-content: ${stylesIf('hasBody', 'space-between', 'space-evenly')};
    margin: 25vw auto;
    min-height: calc(100vh - 50vw);
  }
  @media screen and (min-width: 48rem) {
    min-height: calc(100vh - 60vw);
    margin-bottom: 35vw;
  }
  > * {
    margin: 0;
    padding: 16px 0;
    text-align: center;
    :first-child {
      padding-top: 0;
    }
    @media screen and (min-width: 25.875rem) {
      padding: 0;
    }
  }
  @media (min-width: 53.75rem) {
    font-size: 0.875rem;
    padding: 0 1rem;
    max-width: 100vw;
    min-height: calc(100vh - 20vh);
    margin-top: 2vh;
    margin-bottom: 0;
  }
`;

export const SureSupplyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(100vh - 25vw);
  max-width: 80vw;
  margin: 12.5vw auto;
  font-family: 'HP Simplified', Arial, sans-serif;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  @media screen and (min-width: 23.5rem) {
    justify-content: ${stylesIf('hasBody', 'space-evenly', 'center')};
  }
  @media screen and (min-width: 25.875rem) {
    justify-content: ${stylesIf('hasBody', 'space-between', 'space-evenly')};
    margin: 25vw auto;
    min-height: calc(100vh - 50vw);
  }
  @media screen and (min-width: 48rem) {
    min-height: calc(100vh - 60vw);
    margin-bottom: 35vw;
  }
  > * {
    margin: 0;
    padding: 16px 0;
    text-align: unset;
    :first-child {
      padding-top: 0;
    }
    @media screen and (min-width: 25.875rem) {
      padding: 0;
    }
  }
  @media (min-width: 53.75rem) {
    font-size: 0.875rem;
    padding: 0 1rem;
    max-width: 100vw;
    min-height: calc(100vh - 20vh);
    margin-top: 15vh;
    margin-bottom: 0;
  }
`;

export const ReTargetContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 615px;
  width: 930px;
  border-radius: 24px;
  padding: 32px;
  max-height: 100vh;
  min-height: auto;
  overflow-y: auto;
  box-sizing: border-box;
  max-width: 90vw;
  margin: 0 5vw;
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  @media screen and (min-width: 23.5rem) {
    justify-content: ${stylesIf('hasBody', 'space-evenly', 'center')};
  }
  @media screen and (min-width: 25.875rem) {
    justify-content: ${stylesIf('hasBody', 'space-between', 'space-evenly')};
    margin: 0 auto;
  }
  @media screen and (min-width: 48rem) {
    overflow: hidden;
  }
  > * {
    margin: 0;
    padding: 16px 0;
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    :first-child {
      padding-top: 0;
    }
  }
  @media (min-width: 53.75rem) {
    font-size: 0.875rem;
    max-width: 64rem;
  }
  }
  @media all and (-ms-high-contrast: active) and (max-width: 1100px),
    all and (-ms-high-contrast: none) and (max-width: 1100px) {
    margin-top: 0;
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
   height: 100vh;
   padding: 24px;
   justify-content: space-between;
  }


`;

// This was added to fix the styling as per design
export const ReTargetContentContainer = styled.div`
  text-align: ${(props) => (props.isCompanyTenantPrinter ? 'left' : 'center')};
  @media screen and (max-width: ${breakpoints.tablet}) {
    overflow-y: auto;
    flex-grow: 0;
  }
`;

export const Body = styled.div`
  &&&& {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    @media screen and (min-width: ${breakpoints.mobile}) {
      max-width: 44.5rem;
    }
    @media screen and (max-width: ${breakpoints.mobile}) {
      max-width: 34.5rem;
    }
    padding: 0;
    width: 100%;
    font-family: 'HP Simplified', Arial, sans-serif;
    font-size: 1rem;
    line-height: 1.25;
    p,
    > span > p {
      margin: 1rem 0;
      > a {
        color: #027aae;
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
  }
`;

export const BodyList = styled.span`
  > ul {
    list-style: disc;
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    margin-left: ${(props) => (props.isRTL ? '0rem' : '2rem')};
    margin-right: ${(props) => (props.isRTL ? '2rem' : '0rem')};
  }
`;

export const BodySureSupply = styled.div`
  &&&& {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    @media screen and (min-width: ${breakpoints.mobile}) {
      max-width: 44.5rem;
    }
    @media screen and (max-width: ${breakpoints.mobile}) {
      max-width: 34.5rem;
    }
    padding: 0;
    text-align: center;
    width: 100%;
    font-family: 'HP Simplified', Arial, sans-serif;
    font-size: 1rem;
    line-height: 1.25;
    p,
    > span > p {
      margin: 1rem 0;
      > a {
        color: #027aae;
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
  }
`;

export const ReTargetBody = styled.div`
    ul {
      list-style: disc;
      margin-left: 1.5rem;
    }
  &&&& {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }

    @media screen and (max-width: ${breakpoints.mobile}) {
      font-size: 14px;
      line-height: 20px;
    }
    direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
    padding: 0;
    width: 100%;
    font-family: "Forma DJR UI", "HP Simplified", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    p,
    > span > p {
      margin: 1rem 0;
      > a {
        color: ${colors.interactiveLinkBase};
        text-decoration: underline;
        :hover {
          color: #006691;
        }
        :active {
          color: #004f74;
        }
      }
    }
    @media screen and (min-width: ${breakpoints.mobile}) {
      > div > span > p:nth-of-type(1) {
        margin-bottom: 0;
      }
    }
    @media screen and (max-width: ${breakpoints.mobile}) {
      > div > span:last-child:not(:first-child) > p:last-of-type {
        margin-bottom: 60px;
      }
    }
  }
`;

export const Title = styled.h4`
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
  text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  && {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
      font-size: 20px;
      line-height: 28px;
      text-align: center;
    }
    @media screen and (max-width: ${breakpoints.mobile}) {
      font-size: 20px;
      line-height: 28px;
      text-align: center;
    }
    font-size: 32px;
    font-weight: 500;
    line-height: 40px;
  }
`;

export const ReTargetPrinterButtonLargeContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: 'row';
  justify-content: flex-end;

  & > button > span {
    white-space: 'normal';
  }

  @media screen and (min-width: 768px) and (max-width: 1151px) {
    flex-direction: 'row';
    width: 100%;

    & > button {
      width: 'auto';
    }
  }
`;

export const ReTargetButtonContainer = styled.div`
  display:flex;
  justify-content: flex-end;

  & > button {
    width: auto;
  }
  // greater than or equal to 414 pixels
  @media screen and (min-width:${breakpoints.tablet}) {
    width:100%;
    margin-right: 0;
    &>button:not(:first-of-type) {
      margin-right:1rem;
    }
  }
  // less than or equal to 414 pixels
  @media screen and (max-width:${breakpoints.tablet}) {
    flex-direction:column;
    &>button {
      width: auto;
    }
    &>button:first-of-type {
      margin-left: 0;
      margin-bottom: 0.625rem;
    }
    & >button:last-of-type {
      margin-top: 0.625rem;
    }
    && > button:first-of-type:last-of-type {
    margin-bottom: 0;
    margin-top: 0;
  }
  }

  @media screen and (min-width:500px) and (max-width:500px) and (min-height:530px ) and (max-height:530px) {
    width:100%;
    font-size: 1rem;
    line-height: 1.25rem;
    align-items: center;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    &>button:not(:first-of-type) {
      margin-right:1rem;
    }
    &>button:first-of-type {
      margin-bottom: 0;
    }
  }

  @media only screen and (min-width: 768px), (min-width: 1024px)
  and (max-width: 1024px), (max-width: 1366px)
  and (-webkit-min-pixel-ratio: 1), (-webkit-min-pixel-ratio: 2) {
    /* iPad and iPadPro only with Desktop exception */
    flex-direction: ${(props) => (props.isDesktop ? 'row-reverse' : 'column')};
    width: ${(props) => (props.isDesktop ? '100%' : 'auto')};
    flex-direction: row;
    margin-right: 0;
    &>button:first-of-type {
      margin-left: 0;
      margin-bottom: 0;
      margin-right: ${(props) => (props.isDesktop && props.isRTL ? '1rem' : '0')};
    }
    &>button:last-of-type {
      align-items: center;
      margin-top: 0;
    }
    &>button:not(:first-of-type) {
      margin-right:${(props) => (props.isDesktop ? '1rem' : '0')};
    }
    &&>button:first-of-type:last-of-type {
    margin-bottom: 0;
    margin-top: 0;
  }
  }

  @media all and (-ms-high-contrast: active) and (max-width: 1100px), all and (-ms-high-contrast: none) and (max-width: 1100px) {
    margin-top: 10px;
  }

}
`;
export const StyledButton = styled(Button)`
  && {
    @media screen and (min-width: 0\0) and (min-resolution: 0.001 dpcm) {
      margin-left: 50%;
      transform: translate(-50%);
    }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      font-weight: bold;
    }
    min-height: ${stylesIf('small', '2.25', '2.875')}rem;
    ${stylesIf('small', 'border-radius: 0.5rem;')}
    ${stylesIf(
      'hasBody',
      `
        @media screen and (min-width: 25.875rem) {
          margin-top: 1rem;
        }
      `
    )}
  }
`;

export const Graphic = styled.img`
  @media screen and (min-width: 0\0) and (min-resolution: 0.001dpcm) {
    margin-left: 50%;
    transform: translate(-50%);
  }
  height: ${(props) => (props.isWJA ? '3.25rem' : '6.25rem')};
  width: auto;
`;

export const LogoContainer = styled.div`
  text-align: center;
  padding: 1rem;
`;
export const ToggleLayout = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  max-width: 34.5rem;
  justify-content: center;
  margin: 1rem auto;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 100%;
  }
  @media screen and (min-width: 500px) and (max-width: 500px) and (min-height: 530px) and (max-height: 530px) {
    line-height: 1.25rem;
    font-size: 1rem;
  }

  @media only screen and (min-device-width: 768px),
    (min-device-width: 1024px) and (max-device-width: 1024px),
    (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1),
    (-webkit-min-device-pixel-ratio: 2) {
    max-width: ${(props) => (props.isDesktop ? '100%' : '34.5rem')};
  }
`;

export const RebrandEmptyCard = styled.div`
  @media screen and (width >= ${breakpointsRebrand[
      'xs-min-width'
    ]}) and (width < ${breakpointsRebrand['xm-min-width']}) {
    margin: 0 48px;
  }
  @media screen and (width >= ${breakpointsRebrand[
      'xm-min-width'
    ]}) and (width <= ${breakpointsRebrand['xm-max-width']}) {
    width: 741px;
  }

  @media screen and (width > ${breakpointsRebrand['xm-max-width']}) {
    width: 0 930px;
  }
`;

export const RebrandCardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 930px;
  min-height: 600px;
  overflow-y: auto;

  && {
    @media screen and (max-width: ${breakpoints.small}) {
      align-items: normal;
      min-height: calc(100vh - 32px - 32px - 16px - 40px);
    }
    @media screen and (min-width: ${breakpoints.small}) and (max-width: ${breakpoints.mobile}) {
      min-height: calc(100vh - 32px - 32px - 16px - 20px - 40px);
    }
  }
`;

export const RebrandBackGround = styled.div`
  .clientos-ui-toolkit-device-list {
    min-height: 100vh;
    direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};
    text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
  }

  .clientos-ui-toolkit-device-list__container {
    padding-top: ${spacing.space_sm};
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    .clientos-ui-toolkit-device-list__container {
      padding: 0;
    }
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
    .clientos-ui-toolkit-device-list__image-container img {
      display: none;
    }
  }

  & > :first-child {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .clientos-ui-toolkit-empty-card {
    position: relative;
    z-index: 1;
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
    .clientos-ui-toolkit-device-list__image-container img {
      display: none;
    }
  }
`;

export const RebrandEmptyPageWrapper = styled.div`
  .clientos-ui-toolkit-empty-page {
      .clientos-ui-toolkit-empty-page__content {
        box-sizing: border-box;
      }
    }

  @media screen and (max-width: ${breakpoints.tablet}) {
    .clientos-ui-toolkit-empty-page {
      .clientos-ui-toolkit-empty-page__content {
        padding-bottom: 208px;
        padding-right: 16px;
        padding-left: 16px;
        padding-top: 32px;
      }
    }
  }

   @media screen and (max-width: ${breakpoints.small}) {
    .clientos-ui-toolkit-empty-page {
      .clientos-ui-toolkit-empty-page__content {
        min-height: 0;
      }
    }
  }
`;

export const RebrandEmptyPageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 742px;
  margin: auto;
`;

export const RebrandUserConsentsCardContent = styled(RebrandCardContent)`
  & {
    min-height: auto;
  }
  &&& {
    @media screen and (max-width: ${breakpoints.mobile}) {
      padding-top: 0;
      align-items: normal;
      min-height: calc(100vh - 195px - 1rem - 64px - 32px - 28px);
    }
  }

  &&& {
  @media screen and (max-width: ${breakpoints.small}) {
      min-height: calc(100vh - 195px - 6rem - 64px - 32px - 28px);
  }

`;

export const ReTargetUserConsentsBody = styled(ReTargetBody)`
  &&&& {
    > div > span > p:first-child {
      margin-top: 0;
    }
    ,
    > div > span > p:last-child {
      margin-bottom: 0;
    }
  }
`;

export const RebrandUserConsentsTitle = styled(Title)`
  text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
  margin-bottom: 2rem;
  @media (prefers-color-scheme: dark) {
    color: ${colors.white};
  }
  && {
    @media screen and (max-width: ${breakpoints.mobile}) {
      font-size: 20px;
      line-height: 28px;
      text-align: ${(props) => (props.isRTL ? 'right' : 'left')};
      margin-bottom: 1.5rem;
    }
  }
`;

export const ReTargetUserConsentsButtonLargeContainer = styled(ReTargetButtonContainer)`
  background: ${hexToRgba(colors.interfaceBackgroundPrimary, 0.7)};
  backdrop-filter: blur(4px);
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  & > button > span {
        overflow-wrap: break-word;
        word-wrap: break-word;   
        white-space: normal;     
  }

  @media (prefers-color-scheme: dark) {
    background: ${colors.black};
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: 100%;
    margin-top: 2rem;
    margin-right:0;
    margin-left:0;

    &>button:not(:first-of-type) {
       margin-right:0;
    }
    &>button:first-of-type {
      margin-right:0.5rem;
    }

    &>button:last-of-type {
      margin-left:0.5rem;
    }
  }

  @media only screen and (min-width: 768px), (min-width: 1024px)
  and (max-width: 1024px), (max-width: 1366px)
  and (-webkit-min-pixel-ratio: 1), (-webkit-min-pixel-ratio: 2) {
    /* iPad and iPadPro only with Desktop exception */
    width: ${(props) => (props.isDesktop ? '100%' : 'auto')};
    margin-right: 0;

    &>button:last-of-type {
      align-items: center;
      margin-top: 0;
    }
    &>button:not(:first-of-type) {
      margin-right: '0';
    }
    &&>button:first-of-type:last-of-type {
    margin-bottom: 0;
    margin-top: 0;
  }
  }
`;

export const ReTargetUserConsentsButtonContainer = styled(ReTargetButtonContainer)`
  background: ${hexToRgba(colors.interfaceBackgroundPrimary, 0.7)};
  backdrop-filter: blur(4px);
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  & > button > span {
        overflow-wrap: break-word;
        word-wrap: break-word;   
        white-space: normal;     
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: 100%;
    margin-top: 2rem;
    &>button:not(:first-of-type) {
      margin-right:0.5rem;
    }
  }

  @media (prefers-color-scheme: dark) {
    background: ${colors.black};
  }

  @media screen and (max-width: ${breakpoints.tablet}) {
    border-top: 1px solid ${colors.interfaceStrokeBase};
    width: calc(100% - 48px);
    position: fixed;
    bottom: 0;
    left: 0;
    flex-direction: column;
    padding: 24px;
    & > button:not(:first-of-type) {
      margin-right: 0;
    }
    & > button {
      margin-left: 0;
      margin-right: 0;
      width: auto;
    }
    & > button:first-of-type {
      margin-bottom: 0.5rem;
    }
    & > button:last-of-type {
      margin-top: 0.5rem;
    }
    && > button:first-of-type:last-of-type {
      margin-bottom: 0;
      margin-top: 0;
    }
    @media (prefers-color-scheme: dark) {
      border-top-color: ${colors.inkSecondary};
    }
  }
`;
export const ButtonLoaderWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 24px;
  max-height: 24px;
  
  .clientos-ui-toolkit-loader {
    width: 24px !important;
    height: 24px !important;
    max-width: 24px;
    max-height: 24px;
  }
  
  svg {
    width: 24px !important;
    height: 24px !important;
    max-width: 24px;
    max-height: 24px;
  }
`;
